/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import { ListItem as MaterialListItem } from 'material-ui'

class ListItem extends React.Component {
  render () {
    return (
      <MaterialListItem 
        innerDivStyle={{padding: this.props.leftAvatar ? '10px 16px 10px 60px' : '10px 16px 10px 16px'}}
        {
        ...this.props
        }
      >

      </MaterialListItem>
    )
  }
}

export default ListItem



// WEBPACK FOOTER //
// ./src/generic/list/ListItem.js